import { computed, type ComputedRef } from 'vue'

import { useFeatureFlags } from '@/features/account'

/**
 * The rollout key of the private feature flag. During the pilot only system admins (via the flag's
 * own admin bypass) and whitelisted workspaces see the surface.
 */
export const PLATFORM_ACTIONS_FLAG = 'platform_actions'

export interface UsePlatformActionAccess {
  canView: ComputedRef<boolean>
}

/**
 * Feature-owned visibility seam. The ticket is explicit that the frontend writes NO gating of its
 * own here — it reads the bootstrap `feature_flags` section through `checkFlag` and nothing else.
 * The backend re-checks per request and answers `403 PLATFORM_ACTIONS_DISABLED`, which the page
 * renders with the same disabled state; a sysadmin who reaches the page through the nav's flag
 * bypass therefore lands on that state rather than a broken screen.
 */
export function usePlatformActionAccess(): UsePlatformActionAccess {
  const { checkFlag } = useFeatureFlags()

  return {
    canView: computed(() => checkFlag(PLATFORM_ACTIONS_FLAG)),
  }
}
